var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61467 1.64314C5.81172 1.4439 6.0774 1.33333 6.35285 1.33333H9.64715C9.9226 1.33333 10.1883 1.4439 10.3853 1.64314C10.5826 1.84263 10.6948 2.11474 10.6948 2.4V4H5.30523V2.4C5.30523 2.11474 5.41738 1.84263 5.61467 1.64314ZM3.9719 4V2.4C3.9719 1.76584 4.22098 1.15619 4.66667 0.705555C5.1126 0.254667 5.71899 0 6.35285 0H9.64715C10.281 0 10.8874 0.254667 11.3333 0.705555C11.779 1.15619 12.0281 1.76584 12.0281 2.4V4H15.4286C15.7442 4 16 4.29848 16 4.66667C16 5.03486 15.7442 5.33333 15.4286 5.33333H13.3334V13.6C13.3334 14.2342 13.0843 14.8438 12.6387 15.2944C12.1927 15.7453 11.5863 16 10.9525 16H5.04762C4.41376 16 3.80737 15.7453 3.36143 15.2944C2.91575 14.8438 2.66667 14.2342 2.66667 13.6V5.33333H0.571429C0.255837 5.33333 0 5.03486 0 4.66667C0 4.29848 0.255837 4 0.571429 4H3.9719ZM4 5.33333V13.6C4 13.8853 4.11214 14.1574 4.30944 14.3569C4.50649 14.5561 4.77217 14.6667 5.04762 14.6667H10.9525C11.2279 14.6667 11.4936 14.5561 11.6907 14.3569C11.8879 14.1574 12.0001 13.8853 12.0001 13.6V5.33333H4Z",
    fill: "#2468FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.dc23a8b78471c292d8a5fe8e521ba64c.svg";
export { ForwardRef as ReactComponent };